import React, { Dispatch, SetStateAction } from "react";
import "./FormSectionAceleradora.scss";

import FormInputAceleradora from "../../atoms/form-input-aceleradora/FormInputAceleradora";

interface ISectionFormAceleradora {
    setActiveIndex: Dispatch<SetStateAction<number>>;
    activeIndex: number;
    titleSection: any;
    inputsSection: any;
    formValues: any;
    setInputValue: any;
    inputsErrorList: string[];
    customErrorMessageList: any;
    inputDisabled: string[];
    validBirthDate?: boolean;
    dateState?: any;
    talleresData?: any;
    dateStateHelper?: boolean;
    setDateStateHelper?: any;
}

const FormSectionAceleradora = (props: ISectionFormAceleradora) => {
    return (
        <div
            className={`m-section-form-aceleradora m-section-form-${props.inputsSection[0].seccion}`}
        >
            {props.inputsSection.map((input, index) => {
                // Evita el render del campo tipo checkbox para la autorizacion de datos.
                // Este campo se renderiza en el componente FormBottom.
                if (input.nombreId !== "dataProcessingAuthorization" 
                    && input.nombreId !== "dataProcessingAuthorizationProgram"
                    && input.nombreId !== "dataImageAuthorization") {
                    const a = props.customErrorMessageList.filter(
                        (e) => e.nombreId === input.nombreId
                    );
                    if (input.nombreId === "trainingInterest"){
                        const birthDate : any = new Date(`${props.formValues.birth_date.split('-')[2]}-${props.formValues.birth_date.split('-')[1]}-${props.formValues.birth_date.split('-')[0]}`)
                        const currentDate: any = new Date();
                        const milisecDiff: any = currentDate - birthDate;
                        const age: any = Math.floor(milisecDiff / (1000 * 60 * 60 * 24 * 365.25));
                        if (age >= 18 && age <= 29){
                            return (
                                <FormInputAceleradora
                                key={`input-${input.nombreId}`}
                                title={input.inputPrincipal}
                                value={props.formValues[input.nombreId]}
                                nombreId={input.nombreId}
                                type={input.tipoCampo}
                                setInputValue={props.setInputValue}
                                isError={
                                    props.inputsErrorList.indexOf(
                                        input.nombreId
                                    ) !== -1
                                }
                                errorMessage={
                                    a.length > 0
                                        ? a[0].errorMessage
                                        : input.mensajeError
                                }
                                textoTerminos={input.textoTerminos}
                                tituloBotonTerminos={input.tituloBotonTerminos}
                                checked={
                                    props.formValues[input.nombreId] ? true : false
                                }
                                isRequired={input.obligatorio}
                                disabled={props.inputDisabled?.includes(input.nombreId)}
                                options={input.listaSelect}
                                validBirthDate={props.validBirthDate}
                                tabOrder={input.tabOrder}
                                dateState={props.dateState}
                                ayuda={input.nombreId == "disability" ? props.inputsSection[index]?.ayuda : ""}
                                talleresData={props.talleresData}
                                placeholder={input.placeholder}
                                dateStateHelper={props.dateStateHelper}
                                setDateStateHelper={props.setDateStateHelper}
                            ></FormInputAceleradora>
                            );
                        }
                    }else {
                        return (
                            <FormInputAceleradora
                                key={`input-${input.nombreId}`}
                                title={input.inputPrincipal}
                                value={props.formValues[input.nombreId]}
                                nombreId={input.nombreId}
                                type={input.tipoCampo}
                                setInputValue={props.setInputValue}
                                isError={
                                    props.inputsErrorList.indexOf(
                                        input.nombreId
                                    ) !== -1
                                }
                                errorMessage={
                                    a.length > 0
                                        ? a[0].errorMessage
                                        : input.mensajeError
                                }
                                textoTerminos={input.textoTerminos}
                                tituloBotonTerminos={input.tituloBotonTerminos}
                                checked={
                                    props.formValues[input.nombreId] ? true : false
                                }
                                isRequired={input.obligatorio}
                                disabled={props.inputDisabled?.includes(input.nombreId)}
                                options={input.listaSelect}
                                validBirthDate={props.validBirthDate}
                                tabOrder={input.tabOrder}
                                dateState={props.dateState}
                                ayuda={input.nombreId == "disability" ? props.inputsSection[index]?.ayuda : ""}
                                talleresData={props.talleresData}
                                placeholder={input.placeholder}
                                dateStateHelper={props.dateStateHelper}
                                setDateStateHelper={props.setDateStateHelper}
                            ></FormInputAceleradora>
                        );
                    }
                }
            })}
        </div>
    );
};

export default FormSectionAceleradora;
